export const QUERY_KEYS = {
    useGetDRepListKey: 'useGetDRepListKey',
    useGetNetworkMetricsKey: 'useGetNetworkMetricsKey',
    useFetchAgentsKey: 'agents',
    useGetInfoProposalListKey: 'useGetInfoProposalListKey'
};
